<template>
  <div class="index">
    <p-c-index-page v-if="isPc"></p-c-index-page>
    <mobile-index-page v-else></mobile-index-page>
  </div>
</template>

<script>
  import PCIndexPage from "./PCIndexPage";
  import MobileIndexPage from "./MobileIndexPage";

  export default {
    name: 'index',
    components: {
      PCIndexPage,
      MobileIndexPage
    },
    created() {
      this.isPc = window.screen.width >= 800
    },
    data() {
      return {
        isPc: false,
      }
    }
  }
</script>

<style scoped>
  .index {
    width: 100%;
    height: 100%;
    background: #fff;
  }
</style>
